<template lang="pug">
div.anmeldung
  h1.page-title Anmeldung
  div.section-content 
    span(style="text-align: justify;")
      ol
        li So früh wie möglich auf die Anmeldeliste setzen lassen. Die Anmeldung erfolgt dabei per E-Mail an <strong>Lisa Tietzsch</strong>:<br>
          a(href="mailto:anmeldung@schmetterlinge-herrenberg.de") anmeldung@schmetterlinge-herrenberg.de
        li Gruppenbesuch und Erstgespräch mit Vorstand und Gruppenleiterin innerhalb von 3 Monaten nach Erstkontakt.
        li Wir können nur freiwerdende Plätze belegen, daher besteht kein Anspruch auf Aufnahme. Sie werden zeitnah informiert. Kontakt ist jederzeit möglich!
      p Informationen zu den Gebühren finden Sie weiter unten.
      p &nbsp;
  h1.page-title Aufnahme eines Kindes in die Gruppe
  div.section-content 
    span(style="text-align: justify;")
      ul
        li Wir bieten Plätze für Kinder im Alter zwischen 11 Monaten und 3 Jahren an, wobei eine Aufnahme bis maximal zum 23. Lebensmonat möglich ist.
        li Ca. 2 Wochen vor Start meldet sich eine Erzieherin, um die Eingewöhnung abzustimmen. Für die Eingewöhnung sollten Sie ca. 2 Wochen einplanen.
        li Die Probezeit beträgt 4 Wochen. Während dieser Zeit kann ohne die Einhaltung der dreimonatigen Kündigungsfrist die Betreuung durch den Verein Schmetterlinge e.V. als auch durch den/die Erziehungsberechtigten gekündigt werden.
      p &nbsp;
  h1.page-title Weitere Voraussetzungen
  div.section-content 
    span(style="text-align: justify;")
      ul
        li Mindestens ein Erziehungsberechtigter muss Mitglied bei dem „Schmetterlinge Verein zur Bildung, Erziehung und Betreuung von Kleinkindern e.V.“ sein.
        li Pro Jahr werden von den Eltern 10 Arbeitsstunden (Alleinerziehende 5 Stunden) geleistet. Nicht geleistete Arbeitsstunden werden mit 25 € je fehlende Stunde berechnet.
        li Da die Schmetterlinge ein privater Verein sind, und somit auf die Unterstützung aller angewiesen sind, dürfen bei Bedarf gerne mehr Arbeitsstunden abgeleistet werden.
      p &nbsp;
  h1.page-title Gebühren
  div.section-content 
    span(style="text-align: justify;")
      p Die Betreuungsgebühren beziehen sich auf eine reguläre Betreuungszeit von Montag bis Freitag, außer an den gesetzlichen Feiertagen bzw. während der Ferien, in der Zeit von 07:30 Uhr bis 13:30 Uhr.
      p Maßgebend sind die im Juli 2024 vom Vorstand beschlossenen Gebühren. Alle vorhergehenden Aufstellungen zu den Betreuungsgebühren verlieren hiermit ihre Gültigkeit. Seit dem <strong>1. September 2024</strong> beträgt die monatliche Betreuungsgebühr <strong>310 €</strong>. Zum <strong>1. März 2025</strong> wird die Breuungsgebühr auf <strong>340 €</strong> angehoben. Der August ist beitragsfrei.
      p Der Verein „Schmetterlinge Verein zur Bildung, Erziehung und Betreuung von Kleinkindern e.V.“ ist Träger der freien Jugendhilfe. Eltern oder Erziehungsberechtigte mit geringem Einkommen können daher Zuschüsse zu den Betreuungsgebühren beim Jugendamt beantragen. Entsprechende Formulare können dort angefordert werden. In Zweifelsfällen ist immer ein Antrag zu stellen.
      p Der Beitrag ist für den laufenden Monat jeweils bis zum dritten Werktag dieses Monats auf folgendes Konto zu entrichten:
      p 
      p <strong>Volksbank Herrenberg</strong>
      p <strong>IBAN: DE 88 6039 1310 0000 7110 04</strong>
      p
      p Um die Erteilung eines Dauerauftrages wird gebeten. Bitte reichen Sie bei der Aufnahme des Kindes zusammen mit den Anmeldeunterlagen den Nachweis über das gesamte Familieneinkommen ein.
      p &nbsp;
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebyside from '@/components/Sidebyside';

export default {
  name: 'Anmeldung',
  data() {
    return {
      gebuehren: {
        headers: [
          { label: 'Nettoeinkommen', key: 'netto' },
          { label: 'Gebühr', key: 'gebuehr'}
        ],
        items: [
          { netto: 'bis 1.250 €', gebuehr: '215,00 €' },
          { netto: 'bis 1.500 €', gebuehr: '220,00 €' },
          { netto: 'bis 1.750 €', gebuehr: '225,00 €' },
          { netto: 'bis 2.000 €', gebuehr: '235,00 €' },
          { netto: 'bis 2.250 €', gebuehr: '245,00 €' },
          { netto: 'bis 2.500 €', gebuehr: '265,00 €' },
          { netto: 'ab 2.501 €', gebuehr: '280,00 €' },
        ]
      }
    }
  },
  props: {
  },
  computed: {
    ...mapGetters('global',{
      portrait: 'portrait',
      viewport: 'viewport'
    }),
  },
  methods: {
  },
  components: {
    Sidebyside
  }
}
</script>

<style lang="scss">
.anmeldung {
  padding-top: 20px;
  .page-title {
    padding: 0px 20px;
    padding-bottom: 20px;
  }
  .section-title {
    padding: 0px 20px;
    padding-top: 20px;
  }
  p {
    padding: 0px 20px;
    padding-top: 5px;
    text-align: justify;
    word-break: break-word;
  }
  ol, ul {
    padding-left: 40px;
    padding-right: 20px;
  }
  ul.calc p {
    text-align: left;
    padding: 0px;
    padding-left: 12px;
    text-indent: -12px;
  }
  .wie p, .foerderung p {
    padding: 0px 0px;
  }
  .wie .sidebyside-image{
    justify-content: center;
    img {
      height: 200px;
      width: auto;
      transform: scaleX(-1);
    }
  }
}
</style>
